var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Filter icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 7C4 7.55 4.4 8 4.88889 8H19.1111C19.6 8 20 7.55 20 7C20 6.45 19.6 6 19.1111 6H4.88889C4.4 6 4 6.45 4 7ZM9.99997 17.9999H14C14.55 17.9999 15 17.5499 15 16.9999C15 16.4499 14.55 15.9999 14 15.9999H9.99997C9.44997 15.9999 8.99997 16.4499 8.99997 16.9999C8.99997 17.5499 9.44997 17.9999 9.99997 17.9999ZM17 13.0001H6.99997C6.44997 13.0001 5.99997 12.5501 5.99997 12.0001C5.99997 11.4501 6.44997 11.0001 6.99997 11.0001H17C17.55 11.0001 18 11.4501 18 12.0001C18 12.5501 17.55 13.0001 17 13.0001Z",
    fill: "#ce1f1f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.d9ec1e52ae37054aca663fc77ff6987c.svg";
export { ForwardRef as ReactComponent };